import { Button, styled, Theme, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const Container = styled('div')<Theme, { $active: boolean }>(({ $active, theme }) => ({
  width: '100%',
  height: 'auto',
  borderRadius: 8,
  padding: '60px 30px',
  border: '3px solid white',
}));

export const HeadingContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 30,
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 50,
});

export const Logo = styled('img')({
  height: 70,
  width: 'auto',
});

export const FlexContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 15,
});

export const CustomButton = styled(Button)<Theme, { $active: boolean }>(({ $active, theme }) => ({
  background: $active
    ? theme.palette.type === 'dark'
      ? '#1c2531'
      : COLORS.WHITE
    : theme.palette.type === 'dark'
      ? '#0b0f14'
      : COLORS.WHITE,
  border: '1px solid',
  borderColor: $active ? '#1c2531' : COLORS.PRIMARY,
  color: '#fff',
  height: 61,
  '&.Mui-disabled': {
    opacity: $active ? 1 : 0.2,
  },
}));

export const CenteredContainer = styled('div')({
  textAlign: 'center',
  margin: '10px 0 30px',
  height: 20,
});

export const DisclaimerContainer = styled('div')({
  marginTop: 40,
  '& p': {
    wordBreak: 'normal',
  },
});

export const CustomText = styled(Typography)(({ theme, size }: any) => ({
  fontSize: size || 16,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
}));
